import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { polymorphicFactory } from "./auth-service-tools249.js";
import classes from "./auth-service-tools259.js";
const defaultProps = {
  __staticSelector: "UnstyledButton"
};
const UnstyledButton = polymorphicFactory((_props, ref) => {
  const props = useProps("UnstyledButton", defaultProps, _props);
  const {
    className,
    component = "button",
    __staticSelector,
    unstyled,
    classNames,
    styles,
    style,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector,
    props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...getStyles("root", {
      focusable: true
    }),
    component,
    ref,
    type: component === "button" ? "button" : void 0,
    ...others
  });
});
UnstyledButton.classes = classes;
UnstyledButton.displayName = "@mantine/core/UnstyledButton";
export { UnstyledButton };